import Hero from '../components/Hero'
import Concerts from '../components/Concerts'

function Home({ t, lang }) {
  return (
    <main>
        <Hero t={t} lang={lang} />
        <div className="bg-custom">
          <div className='container text-center'>
            <h1 className='page-title' style={{marginTop:'0', marginBottom: '80px'}}>{t("upcoming_concerts").toUpperCase()}</h1>
            <Concerts t={t} lang={lang} />
            <div style={{height:'50px'}}></div>
          </div>
        </div>
    </main>
  );
}

export default Home;